import { MESSAGE_PARAM, MESSAGE_TYPE_PARAM } from '@common/constants';
import { Alert, AlertColor } from '@mui/material';
import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function MessageQpAlert() {
  const [qp] = useSearchParams();

  const message = qp.get(MESSAGE_PARAM);

  const severity: AlertColor = useMemo(() => {
    const type = qp.get(MESSAGE_TYPE_PARAM);
    return type && isAlertColor(type) ? type : 'info';
  }, [qp]);

  if (!message) {
    return null;
  }

  return <Alert severity={severity}>{message}</Alert>;
}

function isAlertColor(color: string): color is AlertColor {
  return (['success', 'info', 'warning', 'error'] as AlertColor[]).includes(color as AlertColor);
}
